import React from "react"
import {IconButton, Tooltip} from "@mui/material"
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth"

import {useNotification} from "@indebted/components/Notification"

type Props = {
	customerID: string
	caseID: string
	caseType: string
}

function AddReminderButton({customerID, caseID, caseType}: Props) {
	const {notification} = useNotification()

	const handleClick = (e: React.MouseEvent) => {
		e.stopPropagation()
		const url = `${window.location.origin}/customers/${customerID}/cases?CaseID=${caseID}`
		const title = encodeURIComponent(`Case Reminder: ${caseType}`)
		const details = encodeURIComponent(url)
		navigator.clipboard.writeText(url).then(() => {
			notification.success("Case link copied — paste it into the event description")
			window.open(
				`https://calendar.google.com/calendar/render?action=TEMPLATE&text=${title}&details=${details}`,
				"_blank",
			)
		})
	}

	return (
		<Tooltip title="Add reminder">
			<IconButton size="small" onClick={handleClick}>
				<CalendarMonthIcon fontSize="small" />
			</IconButton>
		</Tooltip>
	)
}

export {AddReminderButton}
